import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuilding_groups = z.any()
export type TagsGetBuilding_groups = z.infer<typeof tagsGetBuilding_groups>

export const querystringGetBuilding_groups = z.object({ "municipalityId": z.string().uuid() })
export type QuerystringGetBuilding_groups = z.infer<typeof querystringGetBuilding_groups>

export const responseGetBuilding_groups = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "municipalityId": z.string().uuid(), "name": z.string(), "order": z.number().optional(), "address": z.string().optional(), "image": z.string().optional(), "createdAt": z.string(), "updatedAt": z.string(), "accessibleBuildingCount": z.number(), "buildings": z.array(z.object({ "id": z.string().uuid(), "name": z.string(), "municipalityId": z.string().uuid(), "address": z.string().optional(), "image": z.string().optional() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuilding_groups = z.infer<typeof responseGetBuilding_groups>

interface IGetBuilding_groups extends BaseMethodType {
  tags: TagsGetBuilding_groups,
  querystring: QuerystringGetBuilding_groups,
  response: ResponseGetBuilding_groups
}
export const tagsPostBuilding_groups = z.any()
export type TagsPostBuilding_groups = z.infer<typeof tagsPostBuilding_groups>

export const bodyPostBuilding_groups = z.object({ "municipalityId": z.string().uuid(), "name": z.string().min(1), "address": z.string().optional(), "image": z.string().optional() })
export type BodyPostBuilding_groups = z.infer<typeof bodyPostBuilding_groups>

export const responsePostBuilding_groups = z.object({ "payload": z.object({ "id": z.string().uuid(), "municipalityId": z.string().uuid(), "name": z.string(), "order": z.number().optional(), "address": z.string().optional(), "image": z.string().optional(), "createdAt": z.string(), "updatedAt": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostBuilding_groups = z.infer<typeof responsePostBuilding_groups>

interface IPostBuilding_groups extends BaseMethodType {
  tags: TagsPostBuilding_groups,
  body: BodyPostBuilding_groups,
  response: ResponsePostBuilding_groups
}
export const URL = '/building-groups'
export const validation = {
  get: {
    tags: tagsGetBuilding_groups,
    querystring: querystringGetBuilding_groups,
    response: responseGetBuilding_groups
  },
  post: {
    tags: tagsPostBuilding_groups,
    body: bodyPostBuilding_groups,
    response: responsePostBuilding_groups
  }
}
export interface Building_groups extends BaseRouteType {
  get: IGetBuilding_groups,
  post: IPostBuilding_groups
}